module.exports = __webpack_public_path__ + "img/闲之.69c02b34.png";